import { ReactElement } from 'react';
import {
  buildSecondLevelColumns,
  buildSecondaryData,
} from './second-level-table.data';
import CustomTable from '../../../../../tables/CustomTable';
import { flexify } from '../../../../../../utilities/cssMixins';
import { Fund } from '../../../../../../types/server-data/ClientConfig';
import { Typography } from '@mui/material';
import {
  SupplementaryRulesFirstTableRow,
  SupplementaryRulesPayload,
  SupplementaryRulesSecondTableConfig,
  SupplementaryRulesSecondTableRow,
} from '../../../../../../api/rs-hg/risk/supplementaryRules.types';

interface SupplementaryRulesSecondLevelTableProps {
  rowData: SupplementaryRulesFirstTableRow;
  supplementaryRulesData: SupplementaryRulesPayload;
  selectedPositionDate: string;
  fundDetails: Fund;
  secondTable: SupplementaryRulesSecondTableConfig;
}

function SecondLevelTable(
  props: SupplementaryRulesSecondLevelTableProps,
): ReactElement {

  const secondLevelTableData = buildSecondaryData(
    props.rowData,
    props.supplementaryRulesData,
    props.secondTable,
  );

  const tableColumns = buildSecondLevelColumns(
    props.secondTable,
  ).map((col) => ({
    ...col,
    cellStyle: {
      ...col.cellStyle,
      backgroundColor: 'white',
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
  }));

  return secondLevelTableData.length > 0 ? (
    <CustomTable<SupplementaryRulesSecondTableRow>
      noteExport={{
        fundName: props.fundDetails.name,
        subject: props.secondTable.noteSubject,
        topic: `rule_${props.rowData.number}`,
        positionDate: props.selectedPositionDate,
        shouldCall: false,
      }}

      data={secondLevelTableData}
      options={{
        paging: false,
        search: true,
        exportButton: true,
      }}
      toolbarComponents={{
        toolbarTitle: props.rowData.name,
      }}
      columns={tableColumns}
      csvFields={Object.keys(secondLevelTableData[0] || [])}
      showToolbar={true}
      loading={false}
    />
  ) : (
    <div style={{ padding: '1.25rem', ...flexify() }}>
      <Typography variant="h3">No in-scope data</Typography>
    </div>
  );
}

export default SecondLevelTable;
